// extracted by mini-css-extract-plugin
module.exports = {"ContactData":"ContactForm_ContactData__-nmKM","Input":"ContactForm_Input__2WTUZ"};